import { config, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { InterfaceState } from "@/types/ui";
import { removeBreakdanceBrowserParamFromUrl } from "@/lib/browse-mode";

config.rawError = true;
@Module({ name: "browseMode", namespaced: true })
export default class BrowseModeModule extends VuexModule {
  iframeUrl: string | null = null;
  iframeState: InterfaceState = "loading";
  iframeDocumentTitle: string | null = null;
  iframeWindowUrl: string | null = null;
  backToAdminUrl: string | null = null;

  get iframeDocumentTitleToDisplay(): string | null {
    return this.iframeDocumentTitle || this.iframeUrlToDisplay;
  }

  get iframeUrlToDisplay(): string | null {
    const rawUrl = this.iframeWindowUrl || this.iframeUrl;
    if (rawUrl === null) {
      return null;
    } else {
      return removeBreakdanceBrowserParamFromUrl(rawUrl);
    }
  }

  @Mutation
  setIframeState(iframeState: BrowseModeModule["iframeState"]) {
    this.iframeState = iframeState;
  }

  @Mutation
  setIframeDocumentTitle(title: BrowseModeModule["iframeDocumentTitle"]) {
    this.iframeDocumentTitle = title;
  }

  @Mutation
  setIframeUrl(pageUrl: NonNullable<BrowseModeModule["iframeUrl"]>) {
    this.iframeUrl = pageUrl;
  }

  @Mutation
  setIframeWindowUrl(pageUrl: BrowseModeModule["iframeWindowUrl"]) {
    this.iframeWindowUrl = pageUrl;
  }

  @Mutation
  setBackToAdminUrl(pageUrl: BrowseModeModule["backToAdminUrl"]) {
    this.backToAdminUrl = pageUrl;
  }
}
